import React, { useEffect } from 'react'
import { Button, QRCode } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'
import IconFont from '@/components/IconFonts'

const ClientDownloadPage = () => {
  useEffect(() => {
    const images = document.querySelectorAll('.slideshow img')
    let currentIndex = 0

    const intervalId = setInterval(() => {
      const currentImage = images[currentIndex]
      const nextIndex = (currentIndex + 1) % images.length
      const nextImage = images[nextIndex]

      currentImage.classList.add('hide')
      nextImage.classList.remove('hide')

      currentIndex = nextIndex
    }, 3000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <div className="grid h-full items-center justify-center text-white">
      <SimpleBackground />
      <div className="xl:h-content container z-40 flex flex-col items-center xl:flex-row">
        <div className="my-12 flex h-full w-full">
          <div className="my-12 h-full gap-6">
            <div className="flex flex-col items-center justify-center gap-8 py-6 xl:mt-0">
              <h2 className="text-4xl font-bold">下载Edge浏览器</h2>
              <p className="text-lg">使用最新的微软Edge浏览器,获得最佳体验</p>
              <div className="flex flex-col gap-12 xl:flex-row">
                <div className="flex w-full flex-col items-center justify-center gap-4">
                  <Button ghost size="large" className="flex w-full items-center justify-center" onClick={() => window.open('https://www.microsoft.com/zh-cn/edge/download')}>
                    <IconFont icon="icon-connect" />
                    点击下载
                  </Button>
                  <QRCode value="https://www.microsoft.com/zh-cn/edge/download" size={180} bgColor="white" icon="/edge.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Object.assign(ClientDownloadPage as any, {
  title: '下载 · 灵缇赛事系统',
  description: '下载灵缇赛事系统支持的 Edge 浏览器版本，体验完整的赛事编排、计分、晋级与排名功能。',
})

export default ClientDownloadPage
